import ActionTypes from "../inc/ActionsTypes";

const defaultState = {
    entity:[]
}
const EntityReducter = (state = defaultState, actions) =>{
    if(actions.type === ActionTypes.SET_ENTITY){
        state = {
            ...state,
            entity:actions.payload
        }
    }
    return state;
}
export default EntityReducter;